import { render, staticRenderFns } from "./CurrentAttendeesComponent.vue?vue&type=template&id=4d90b876&scoped=true"
import script from "./CurrentAttendeesComponent.vue?vue&type=script&lang=js"
export * from "./CurrentAttendeesComponent.vue?vue&type=script&lang=js"
import style0 from "./CurrentAttendeesComponent.vue?vue&type=style&index=0&id=4d90b876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d90b876",
  null
  
)

export default component.exports